import * as R from 'ramda'

import { SHOW_MESS_APP,
         } from '../types'
  
const initialState = {
    curmessage : { open : false , mess : ""},
 };

export default function mainscreen(state = initialState, {type,payload}) {
    switch (type) {
        case SHOW_MESS_APP:
            return {
            ...state,
            curmessage : payload
            }
       default:
            return state;
    }
}